import './contact.scss';
import { setupLayout } from '../Shared/layout';
import { setupGoogleMap } from '../../src/module/google-map';
import { setupContactForm } from '../Shared/Component/ContactForm/contact-form';
import { appConfig } from '../../src/appConfig';

setupLayout();

const languageIsoCode = (document.getElementById('inputHiddenForPageLanguageIsoCode') as HTMLInputElement).value;
const googleMapConfig = {
    ...appConfig.googleMapSetting,
    ...{
        languageIsoCode
    }
}
setupLayout();
setupGoogleMap(googleMapConfig);
setupContactForm('contactForm');
